import { useEffect, useRef, useState } from 'react'
import adNekoImage from '../assets/adneko.webp'
import { type AdSlotType } from '../config/ads'
import { t } from '../i18n/translations'
import { getAdRewardDisclosure } from '../services/adRewardDisclosure'
import { registerAdNekoPopup, unregisterAdNekoPopup } from '../services/ads'

interface PopupState {
  slot: AdSlotType
  onClose: (accepted: boolean) => void
}

export function AdNekoPopup() {
  const [state, setState] = useState<PopupState | null>(null)
  const cancelButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    registerAdNekoPopup((slot, onClose) => {
      setState({ slot, onClose })
    })
    return () => unregisterAdNekoPopup()
  }, [])

  useEffect(() => {
    if (!state) return
    cancelButtonRef.current?.focus()
  }, [state])

  if (!state) return null

  const disclosure = getAdRewardDisclosure(state.slot)

  const close = (accepted: boolean) => {
    const cb = state.onClose
    setState(null)
    cb(accepted)
  }

  return (
    <div
      className="ad-neko-popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ad-neko-popup-title"
      aria-describedby="ad-neko-popup-detail"
      onClick={() => close(false)}
    >
      <div
        className="ad-neko-popup__dialog"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Escape') close(false)
        }}
      >
        <h2 id="ad-neko-popup-title" className="ad-neko-popup__title">
          {t('adNekoTitle')}
        </h2>

        <div className="ad-neko-popup__body">
          <img src={adNekoImage} alt={t('adNekoTitle')} className="ad-neko-popup__image" />
          <div id="ad-neko-popup-detail" className="ad-neko-popup__bubble">
            <p className="ad-neko-popup__headline">{disclosure.title}</p>
            <p className="ad-neko-popup__requirement">{disclosure.requirement}</p>
            <p className="ad-neko-popup__reward">{disclosure.reward}</p>
            <p className="ad-neko-popup__note">{disclosure.incompleteNote}</p>
          </div>
        </div>

        <div className="ad-neko-popup__actions">
          <button
            type="button"
            className="btn btn--primary"
            onClick={() => close(true)}
          >
            {t('adWatch')}
          </button>
          <button
            ref={cancelButtonRef}
            type="button"
            className="btn btn--secondary"
            onClick={() => close(false)}
          >
            {t('adCancel')}
          </button>
        </div>
      </div>
    </div>
  )
}
